import {
  FaCarrot,
  FaChild,
  FaDrumstickBite,
  FaHamburger,
  FaPizzaSlice,
  FaUtensils,
} from 'react-icons/fa';
import { ChangeCards } from '../components/change-cards';
import kebabDishes from './dishes/kebab.json';
import pizzaAndPastaDishes from './dishes/pizza-and-pasta.json';
import turkishDishes from './dishes/turkish.json';
import kidsDishes from './dishes/kids.json';
import snackDishes from './dishes/snack.json';
import saladDishes from './dishes/salad.json';

export type TabName =
  | 'Dönergerichte'
  | 'Pizza & Nudel'
  | 'Türkisches'
  | 'Kinder'
  | 'Imbiss'
  | 'Salate';

export type TabItem = {
  id: TabName;
  icon: JSX.Element;
  content: JSX.Element;
};

export const tabItems: TabItem[] = [
  {
    id: 'Dönergerichte',
    icon: <FaDrumstickBite />,
    content: <ChangeCards dishes={kebabDishes} />,
  },
  {
    id: 'Pizza & Nudel',
    icon: <FaPizzaSlice />,
    content: <ChangeCards dishes={pizzaAndPastaDishes} />,
  },
  {
    id: 'Türkisches',
    icon: <FaUtensils />,
    content: <ChangeCards dishes={turkishDishes} />,
  },
  {
    id: 'Kinder',
    icon: <FaChild />,
    content: <ChangeCards dishes={kidsDishes} />,
  },
  {
    id: 'Imbiss',
    icon: <FaHamburger />,
    content: <ChangeCards dishes={snackDishes} />,
  },
  {
    id: 'Salate',
    icon: <FaCarrot />,
    content: <ChangeCards dishes={saladDishes} />,
  },
];
